import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg viewBox="0 0 20 20" {...props}>
      <path
        d="M 3.982 4.675 C 2.135 7.247, 1.271 8.966, 2.062 8.496 C 6.116 6.087, 10 2.606, 10 1.381 C 10 -1.389, 7.259 0.111, 3.982 4.675 M 9.353 8.250 C 5.579 12.787, 1.818 17.400, 0.996 18.500 C -0.428 20.404, -0.404 20.428, 1.500 19.004 C 10.544 12.241, 20 3.494, 20 1.892 C 20 -2.214, 16.139 0.091, 9.353 8.250 M 14.067 14.066 C 12.270 16.303, 10.967 18.301, 11.173 18.506 C 11.853 19.187, 19.924 12.524, 19.963 11.250 C 20.037 8.762, 17.265 10.086, 14.067 14.066"
        stroke="none"
        fill="#fffcfc"
        fillRule="evenodd"
      />
      <path d="" stroke="none" fill="#fcfcfc" fillRule="evenodd" />
    </Svg>
  );
};

export default Icon;
